interface IProps {
  isClicked: boolean;
}

export const DownArrowIcon = ({ isClicked }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
    >
      <path
        d="M0.910157 10.791L2.16358 9.49472L5.0408 12.4989L5.05229 5.12111e-07L6.82017 0.00183809L6.80868 12.4667L9.6638 9.51309L10.9102 10.8149L5.89822 16L0.910157 10.791Z"
        fill={isClicked ? "#fff" : "#004A80"}
      />
    </svg>
  );
};

export const UpArrowIcon = ({ isClicked }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
    >
      <path
        d="M11.1865 5.209L9.80776 6.50528L6.64281 3.50115L6.63017 16L4.68551 15.9982L4.69815 3.5333L1.55751 6.48691L0.186523 5.18512L5.69965 0L11.1865 5.209Z"
        fill={isClicked ? "#fff" : "#004A80"}
      />
    </svg>
  );
};
